import { LayoutModule } from '../../../../layout/modules';
import PersonIcon from '@mui/icons-material/Person';
import { useCasesGeneralDetail } from './hook';
import { CasesGeneralDetailActions } from './actions';
import { CaseGeneralAccountInfo } from './accountInfo';
import { CasesGeneralRegisterHistory } from './registerHistory';
import { CasesGeneralInfoData } from './caseGeneral';
import { CasesGeneralValidate } from './sectionValidate';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import {
    isSupervisor,
    isTrainerOrQuality,
} from '../../../../../shared/types/profiles';

export const CaseGeneralDetail = () => {
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const { caseGeneral, loading } = useCasesGeneralDetail();

    const additionalButtons =
        !isSupervisor(type) && !isTrainerOrQuality(type) ? (
            <CasesGeneralDetailActions caseGeneralId={caseGeneral?.id || ''} />
        ) : undefined;

    return (
        <>
            <LayoutModule
                title="Detalle casos generales"
                titleChildren="Detalle cuenta"
                icon={<PersonIcon sx={{ color: 'primary.main' }} />}
                additionalButtons={additionalButtons}
            >
                <CaseGeneralAccountInfo
                    account={caseGeneral?.account}
                    loading={loading}
                />
            </LayoutModule>
            <CasesGeneralInfoData casesGeneral={caseGeneral} />
            <CasesGeneralValidate casesGeneral={caseGeneral} />
            <CasesGeneralRegisterHistory casesGeneral={caseGeneral} />
        </>
    );
};
